document.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('.js-support-form');
    const fullname  = form.elements['full_name'];
    const email     = form.elements['email'];
    const phone     = form.elements['phone'];
    const subject   = form.elements['subject'];
    const message   = form.elements['message'];
    const selectContainer = document.querySelector('.js-mb-select');

    fullname.addEventListener('keyup', () => m.validation.hideError(fullname));
    email.addEventListener('keyup', () => m.validation.hideError(email));
    phone.addEventListener('keyup', () => m.validation.hideError(phone));
    selectContainer.addEventListener('click', () => m.validation.hideError(subject));

    form.addEventListener('submit', (e) => {
       e.preventDefault();

        if (!checkFields(fullname, email, phone, subject, message)) return;

        console.log('Support Form Data is valid');

        const data = {
            "brand_id": "CAPITALIX",
            "full_name" : fullname.value,
            "email": email.value,
            "phone": phone.value,
            "subject": subject.value,
            "message": message.value || '--'
        };
        const success = () => {
            showFormModal(
                'successModal',
                'success',
                m.trans.get('Success'),
                m.trans.get('Your message has been successfuly sent.<br/> Thank you for contacting us!')
            );

            form.reset();
        };
        const error = (resp) => {
            if (resp.details.property === "phone") {
                showFormModal(
                    'errorModal',
                    'error',
                    m.trans.get('Error'),
                    m.trans.get('Please enter a valid phone number.<br/> Try to use format: +XX XXX XXX XXX')
                );
            } else {
                showFormModal(
                    'errorModal',
                    'error',
                    m.trans.get('Error'),
                    m.trans.get(resp.details.message)
                );
            }
        };
        m.api.send(data, success, error, 'communications/contact-us');
    });

    // select
    selectContainer.addEventListener('click', e => {
        e.stopPropagation();
        window.addEventListener("click", closeSelect);

        function closeSelect() {
            if (selectContainer.classList.contains('mb-select_active')) {
                selectContainer.classList.remove('mb-select_active');
                window.removeEventListener("click", closeSelect);
            }
        }

        selectContainer.classList.toggle('mb-select_active');

        if (!e.target.closest('.mb-select__item')) return;

        subject.value = e.target.textContent;
    });

    /**
     *
     * @param fullname
     * @param email
     * @param phone
     * @param subject
     * @param message
     * @returns {boolean}
     */
    function checkFields(fullname, email, phone, subject, message) {
        let flag = true;

        if (!m.validation.fullName(fullname)) flag = false;
        if (!m.validation.email(email)) flag = false;
        if (!m.validation.phone(phone)) flag = false;
        if (!m.validation.subject(subject)) flag = false;

        return flag;
    }

    /**
     *
     * @param id
     * @param type
     * @param title
     * @param content
     * @returns {Node}
     */
    function showFormModal(id, type, title, content) {
        const modal = document.createElement('div');
        modal.id = id;
        modal.className = 'contact-modal contact-modal_' + type;

        const modalWrap = document.createElement('div');
        modalWrap.className = 'contact-modal__wrap';

        const modalContent = document.createElement('div');
        modalContent.className = 'contact-modal__content';

        const modalClose = document.createElement('button');
        modalClose.className = 'contact-modal__close';
        modalClose.innerHTML = 'x';
        modalClose.addEventListener('click', () => hideFormModal(id));

        const modalHead = document.createElement('div');
        modalHead.className = 'contact-modal__head';
        modalHead.innerHTML = title;
        modalHead.append(modalClose);

        const modalBody = document.createElement('div');
        modalBody.className = 'contact-modal__body';
        modalBody.innerHTML = content;

        modalContent.append(modalHead, modalBody);
        modalWrap.append(modalContent);
        modal.append(modalWrap);
        document.body.append(modal);

        // hide after 4 seconds
        setTimeout(() => hideFormModal(id), 4000);
    }

    /**
     *
     * @param id
     */
    function hideFormModal(id) {
        if (!id) return;

        const modal = document.getElementById(id);
        modal.remove();
    }
});